(function ($) {
  Drupal.behaviors.productCollectionHeroV2 = {
    attach: function (context, settings) {
      var $template = $('.product_collection_hero-v2'),
        $tabs = $('.product-collection-tabs', $template);

      $('.js-tabs-list', $tabs).trigger('add_current');
    }
  };
})(jQuery);
